// extracted by css-extract-rspack-plugin
export default {"top3Operators":"p_2eD2","operators":"ItnYLP","operator":"BSKuIG","profession":"J1IoKe","icon":"Xwc5rs","name":"jbRVrr"};